import React from "react";
import { Switch, List } from "devextreme-react";

export default React.memo((props) => (
  <List
    className="notificacion-mantenedor-list-item"
    items={props.data.Notifications}
    itemComponent={(item) => (

      <React.Fragment>

        <div className="notification-list-item-flex">
          <div className="notification-check">
            {/* <Switch
              id={item.NotificationId}
              onValueChanged={(check) => props.OnDisabledChannels(check, props.data.NotificationGroupId)}
              defaultValue={item.Active}
            /> */}

          </div>
          <div className="notification-text">

            <span className="name">
              {item.NotificationDescription}
            </span>
          </div>
          <div className="notificaction-checks">
            {/* <Switch
              id="Push"
              className="checkMargin"
              disabled={item.Active === false}
              defaultValue={item.ChannelSelection.Push}
              onValueChanged={(check) => props.OnChangedSingleChannel(check, props.data.NotificationGroupId, item.NotificationId)}
            /> */}
            <Switch
              switchedOffText="No"
              switchedOnText="Si"
              id="Mail"
              className="checkMargin"
              disabled={!item.ValidChannels.Mail || item.Active === false}
              defaultValue={item.ChannelSelection.Mail}
              onValueChanged={(check) => props.OnChangedSingleChannel(check, props.data.NotificationGroupId, item.NotificationId)}
            />
            <Switch
              switchedOffText="No"
              switchedOnText="Si"
              id="Sms"
              className="checkMargin"
              disabled={!item.ValidChannels.Sms || item.Active === false}
              defaultValue={item.ChannelSelection.Sms}
              onValueChanged={(check) => props.OnChangedSingleChannel(check, props.data.NotificationGroupId, item.NotificationId)}
            />
          </div>
        </div>
      </React.Fragment>
    )}
  />

));
